import SwGHelper from '../../common/helpers/SubscribeWithGoogleHelper';
import { model } from '../core/model'
import { Config } from "../core/config"
import analytics from "../helpers/analytics"


const libs = () => {
    if (!model.Window.lightMode) {
        startRegistrationLibs('googlebutton');
        startRegistrationLibs('googlepayContainer');
        startGoogleTagManager();
        setTimeout(() => {
            startComscore();
            initWChat();
        }, 0);
    }
}

const startGoogleTagManager = function () {
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&amp;l=' + l : ''; j.async = false; j.src =
                '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', Config.gtmId);
}


const startComscore = function () {
    var _comscore = _comscore || [];
    _comscore.push({ c1: "2", c2: "6906398" });
    (function () {
        var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
        s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
        el.parentNode.insertBefore(s, el);
    })();
}

const initWChat = function () {
    if (Config.idWcentrix) {
        setTimeout(function () {
            var s;
            if (window.innerWidth >= 767) {
                s = document.createElement("script");
                s.defer = true;
                s.src = "https://wcentrix.net/tabhelp/wctabs.aspx?id=" + Config.idWcentrix + "&" + (new Date).getTime();
                document.head.appendChild(s);
            }
        }, Config.wCentrixTime);
    }
}

const startRegistrationLibs = function (div) {
    if (!div)
        return;
    
    if (document.getElementsByClassName(div)[0]) {
        let googleBtnData = document.getElementsByClassName(div)[0].dataset;
        let { name, price, sku } = googleBtnData;
        let payload = analytics.getGoogleTransactionPayload(name, price, sku);
        if (window.GoogleSubscribe && window.GoogleSubscribe.start) {
            window.GoogleSubscribe.start(
                function(){SwGHelper.BtnGoogle(div);},
                payload,
                analytics.trackCustomDimension);
        }
    }
}




export default libs;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/libs/index.js